export default {
    spots: 'spots',
    spots_infinity: 'spots_infinity',
    current_spot: 'current_spot',
    current_invoice: 'current_invoice',
    reviews: 'reviews',
    userCompanies: 'user_companies',
}